module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 005.f2339e94.jpg";